<template>
  <div class="agencyBox">
    <Download></Download>
    <div class="contentBox">
      <div class="top" v-if="info">
        <div class="carousel">
          <swiper ref="mySwiper" :options="swiperOption" class="swiper-wrapper">
            <swiper-slide
              v-for="(item, index) in info.organizationimagesDtos"
              :key="index"
            >
              <img :src="item.imageurl" />
            </swiper-slide>
          </swiper>
          <div class="carouselIndex">
            <span>{{
              carouselIndex + 1 + "/" + info.organizationimagesDtos.length
            }}</span>
          </div>
        </div>
        <div class="infoBox">
          <p class="name ellipsis">{{ info.name }}</p>
          <ul
            class="classes"
            type="public"
          >
            <li>{{baseType || firstBaseType}}</li>
            <li :style="{'color':util.spanStyle(info.artcode).color,'background':util.spanStyle(info.artcode).bg}">{{info.artcode}}</li>
            <!-- <li
              v-for="(item,index) in classesList"
              :key="index"
              :style="index==0?{'color':util.btnStyle(item).color,'background':util.btnStyle(item).bg}:{}"
            >{{index==0?util.btnStyle(item).text:item.tag}}
            </li> -->
          </ul>
          <div class="scoreBox">
            <div class="score">
              <i
                class="full"
                v-for="(item1, index1) in startBox[1]"
                :key="index1"
              ></i>
              <i
                class="half"
                v-for="(item1, index1) in startBox[2]"
                :key="index1"
              ></i>
              <i
                class="none"
                v-for="(item1, index1) in startBox[0]"
                :key="index1"
              ></i>
              <span>{{
                util.toFixed(info.staringcount || 5,
                  1
                )
              }}</span>
            </div>
            <!-- <span>{{ info.evaluationcount? util.showCount(info.evaluationcount) + '条评价' :'暂无评价' }}</span> -->
          </div>
          <div class="detail">
            <ul>
              <li>
                <div class="label ellipsis">
                  <i class="time"></i>
                  <span class="desc">开放时间</span>
                  <span>{{ info.businesshours }}</span>
                </div>
                <!-- <div class="arrow"></div> -->
              </li>
              <li>
                <a :href="'tel:' + info.contactsphone">
                  <div class="label ellipsis">
                    <i class="tel"></i>
                    <span class="desc">联系电话</span>
                    <span>{{ info.contactsphone || '暂无联系电话'}}</span>
                  </div>
                  <div class="arrow"></div>
                </a>
              </li>
              <li @click="goto('location')">
                <div class="label ellipsis">
                  <i class="location"></i>
                  <span class="desc">所在地址</span>
                  <span>{{ info.address }}</span>
                </div>
                <div class="arrow"></div>
              </li>
           
            </ul>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="courseBox common" >
          <div class="commonTop">
            <div class="topLeft">
              <span class="title"
                >基地简介</span
              >
            </div>
           
          </div>
          <div class="profile" v-html="info.profile"></div>
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Components from "./components/components.vue";
import NotData from "@/components/notData";
import Download from "@/components/download.vue";

export default {
  name: "baseDetail",
  metaInfo() {
    return {
      title: '基地详情',
    };
  },
  data() {
    return {
      teamInfoId: "",
      info: "",
      carouselIndex: 0,
      swiperOption: {
        loop: false,
        onSlideChangeEnd: function (swiper) {
          this.carouselIndex = swiper.rellIndex;
        }.bind(this),
      },
      teacher: [],
      teacherType: [],
      artTypeIndex: 0,
      course: [],     //线上课程列表
      coursecount:0, //线上课程数量
      traincourse:[], //线下培训列表
      trainnumber:0,//线下培训数量
      filterIndex: 0,
      filter: [
        { name: "全部", value: "" },
        { name: "在线课程", value: "1000" },
        { name: "面授课程", value: "2000" },
      ],
      evaluation: [],
      evaluationTotal: 0, //评价总数
      teacherTotal:0, //教师总数
      startBox: [],
      live: [],
      liveTotal: 0,
      active: [],
      activeTotal: 0,
      firstBaseType:''
    };
  },
  components: { swiper, swiperSlide, Components, NotData, Download },
  created() {
    this.teamInfoId = this.$route.query.teamInfoId
      ? this.$route.query.teamInfoId
      : '20240323002';
    if (this.$store.state.state.baseTypeList&&this.$store.state.state.baseTypeList.length == 0) {
      this.getBaseType();
    } else {
      this.baseTypeList = this.$store.state.state.baseTypeList;
    }
  },
  mounted() {
    this.getInfo();
  },
  computed : {
    baseType () {
      let text = ''
      this.baseTypeList && this.baseTypeList.filter((item) => {
        if (item.domaincode == this.info.tearmtype) {
          text = item.shortnamecn
        }
      })
      return text
    }
  },
  watch: {
    // ["artTypeIndex"]() {
    //   this.getTeacher();
    // },
    // ["filterIndex"]() {
    //   this.getCourse();
    // },
  },
  methods: {
    componentsPopUp(data) {
      var url = "",
        obj = {};
      switch (data.type) {
        case "course":
          if (data.businesstype == 1000) {
            url = "/h5/course/publicCourseDetails";
            obj.courseid = data.id;
          } else if (data.businesstype == 1001) {
            url = "/h5/course/payCourseDetails";
            obj.courseid = data.id;
          } else if (data.businesstype == 1005) {
            url = "/h5/course/belowCourseDetails";
            obj.adjcourseid = data.id;
          }
          break;
        case "teacher":
          url = "/h5/serve/volunteers";
          obj.teacherId = data.id;
          break;

        default:
          break;
      }
      if (url) {
        this.$router.push({ path: url, query: obj });
      }
    },
    getBaseType() {
      var obj = {
        domainname: "YANG_ORGANIZATION_TEAM",
      };
      this.$post("/gart-common-api/api/cmn/domaindata/index", obj).then(
        (res) => {
          if (res.code == 1) {
            var data = res.data ? res.data : [];
            this.baseTypeList = res.data
            this.$store.commit("uploadBaseType", data);
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    getInfo() {
      var obj = {
        teaminfoid: this.teamInfoId,
      };
      this.$post(
        "/gart-common-api/api/crm/organization/queryByOrganization",
        obj
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            this.info = res.data;
            var star =
              res.data.staringcount  || 5;
            this.startBox = this.util.changeStart(star);
            if (
              res.data.organizationimagesDtos &&
              res.data.organizationimagesDtos.length > 1
            ) {
              this.swiperOption.loop = true;
            }
            // this.getActive();
            // this.getCourse()
            // this.getTraning()
            // if (this.info.membernumber) {
            //   this.getArtType();
            // }
            // if (this.info.worksnumber) {
            //   this.getCourse();
            // }
            // if (this.info.evaluationcount) {
            //   this.getEvaluation();
            // }
            this.shareLink();
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    getArtType() {
      var obj = {
        organizationid: this.teamInfoId,
      };
      this.$post(
        "/gart-common-api/api/crm/teacher/queryByLclasscodeForOrganization",
        obj
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            var data = res.data && res.data.rows ? res.data.rows : [];
            this.teacherType = [{ lclasscode: "", lclassname: "全部" }].concat(
              data
            );
            this.getTeacher();
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    getTeacher() {
      var obj = {
        organizationid: this.teamInfoId,
        lclasscode: this.teacherType[this.artTypeIndex]
          ? this.teacherType[this.artTypeIndex].lclasscode
          : "",
        pageNum: 1,
        pageSize: 3,
      };
      this.$post(
        "/gart-common-api/api/crm/teacher/queryTeacherList",
        obj
      ).then((res) => {
        if (res.code == 1) {
          // if (res.data.rtncode == 1) {
            this.teacher = res.data && res.data.rows ? res.data.rows : [];
            this.teacherTotal = res.data && res.data.total ? res.data.total : 0
          //   console.log(this.teacher)
          // } else {
          //   this.util.toast({ msg: res.data.rtnmsg });
          // }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
     getCourse() {
      var obj = {
        pageNum: 1,
        pageSize: 3,
        type:'2000',
        teacherid: '',
        organizationid: this.info.organizationid,
        lclasscode:'',
        coursetype: '1000',
      };
      this.$post("/gart-common-api/api/scm/course/queryOrganizationCoursForEs", obj).then(
        (res) => {
          if (res.code == 1) {
            this.course = res.data && res.data.rows ? res.data.rows : [];
            this.coursecount = res.data && res.data.total ? res.data.total : 0
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    getTraning() {
      var obj = {
        pageNum: 1,
        pageSize: 3,
        type:'2000',
        teacherid: '',
        organizationid: this.info.organizationid,
        lclasscode:'',
        coursetype: '2000',
      };
      this.$post("/gart-common-api/api/scm/course/queryOrganizationCoursForEs", obj).then(
        (res) => {
          if (res.code == 1) {
            this.traincourse = res.data && res.data.rows ? res.data.rows : [];
            this.trainnumber = res.data && res.data.total ? res.data.total : 0
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    // getCourse() {
    //   var obj = {
    //     organizationid: this.teamInfoId,
    //     pageNum: 1,
    //     pageSize: 3,
    //     type: 2000,
    //     coursetype: this.filter[this.filterIndex].value,
    //   };
    //   this.$post(
    //     "/gart-common-api/api/scm/course/queryOrganizationCoursForEs",
    //     obj
    //   ).then((res) => {
    //     if (res.code == 1) {
    //       this.course = res.data && res.data.rows ? res.data.rows : [];
    //     } else {
    //       this.util.toast({ msg: res.message });
    //     }
    //   });
    // },
    getTrainCourse () {
      var obj = {
        // organizationid: this.teamInfoId,
        pageNum: 1,
        pageSize: 3,
        lat:'',
        lon:'',
        city:'',
        county:'',
        area:'',
        distance:'',
        availablecountFlag:'',
        lclasscodes:'',
        sclasscodes:'',
      };
      this.$post(
        "/gart-common-api/api/scm/adjcourse/queryAdjCourseForEs",
        obj
      ).then((res) => {
        if (res.code == 1) {
          this.trainnumber = res.data && res.data.total ? res.data.total : 0
          this.traincourse = res.data && res.data.rows ? res.data.rows : [];
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    getActive() {
      var obj = {
        organizationid: this.teamInfoId,
      };
      this.$post(
        "/gart-common-api/api/scm/activity/queryActivityByOrganizationId",
        obj
      ).then((res) => {
        if (res.code == 1) {
          this.active = res.data && res.data.rows ? res.data.rows : [];
          this.activeTotal = res.data&&res.data.total||0;
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    getLive() {
      var obj = {
       organizationid: this.teamInfoId,
      };
      this.$post(
        "/gart-common-api/api/scm/activity/queryLiveActivityByOrganizationId",
        obj
      ).then((res) => {
        if (res.code == 1) {
            this.live = res.data&&res.data.rows ? res.data.rows : [];
            this.liveTotal = res.data.total;
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },

    getEvaluation() {
      var obj = {
        organizationid: this.teamInfoId,
        pageNum: 1,
        pageSize: 3,
      };
      this.$post(
        "/gart-common-api/api/crm/customercomment/queryByComment",
        obj
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            var data = res.data && res.data.rows ? res.data.rows : [];
            this.evaluation = data;
            this.evaluationTotal = res.data.total;
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    goto(type, data) {
      var obj = {},
        url = "";
      switch (type) {
        case "training":
        case "online":
          url = "/h5/serve/courseList";
          obj = {
            id: this.teamInfoId,
            type: type,
            // course: type
            from : 'agency'
          };
          break;
        case "courseDetail":
          if (data.coursetype == 2000) {
            url = "/h5/course/belowCourseDetails";
            obj.adjcourseid = data.courseid;
          } else if (data.coursetype == 1001) {
            url = "/h5/course/payCourseDetails";
            obj.courseid = data.courseid;
          } else if (data.coursetype == 1000) {
            url = "/h5/course/publicCourseDetails";
            obj.courseid = data.courseid;
          }
          break;
        case "teacher":
          url = "/h5/serve/teacherList";
          obj = {
            teamInfoId: this.teamInfoId,
          };
          break;
        case "teacherDetail":
          url = "/h5/serve/volunteers";
          obj = {
            teacherId: this.teacher[data.index].teacherid,
          };
          break;
        case "evaluation":
          url = "/h5/serve/evaluationList";
          obj = {
            id: this.teamInfoId,
            type: "agency",
          };
          break;
        case "detail":
          url = "/h5/serve/agencyDetail";
          obj = {
            teamInfoId: this.teamInfoId,
          };
          break;
        case "location":
          window.location.href =`https://uri.amap.com/marker?position=${this.info.locationx},${this.info.locationy}&name=${this.info.name}`
          break;
        case "liveList":
          url = "/h5/serve/liveList";
          obj = {
            teamInfoId: this.teamInfoId,
          };
          break;
        case "liveDetail":
          url = "/h5/course/live";
          obj = {
            activityId: data.data.activityid,
          };
          break;
        case "activeList":
          url = "/h5/serve/activeList";
          obj = {
            teamInfoId: this.teamInfoId,
          };
          break;
        case "activeDetail":
          url = "/h5/index/activityDetial";
          obj = {
            activityid: data.data.activityid
          };
          break;
        default:
          break;
      }
      if (url) {
        this.$router.push({
          path: url,
          query: obj,
        });
      }
    },
    shareLink() {
      var _this = this;
      var url = _this.$store.state.state.shareUrl;
      url += "#/h5/serve/agency?teamInfoId=" + this.teamInfoId;
      var data = {
        title: this.info.sharetitle,
        desc: this.info.signature ? this.info.signature : "", // 分享描述
        url: url,
        imgUrl: this.info.shareicon,
      };
      this.util.shareLink(this, data).then(function () {});
    },
  },
};
</script>

<style lang="scss" scoped>
.agencyBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: auto;
  color: rgba(45, 45, 45, 1);
  background: rgba(246, 247, 248, 1);
  display: flex;
  flex-direction: column;
  .contentBox {
    flex: 1;
    overflow: auto;
    .top {
      .carousel {
        position: relative;
        img {
          width: 100%;
          height: 56vw;
          object-fit: cover;
        }
        .carouselIndex {
          position: absolute;
          right: 16px;
          bottom: 16px;
          display: inline-block;
          z-index: 10;
          span {
            font-size: 10px;
            line-height: 14px;
            color: rgba(255, 255, 255, 1);
            padding: 6px 12px;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 14px;
          }
        }
      }
      .infoBox {
        background: #fff;
        padding: 16px 16px 8px;
        .name {
          color: #1F262E;
          font-size: 22px;
          line-height: 30px;
          font-weight: bolder;
        }
        .classes {
            margin-top: 8px;
            display: flex;
            flex-direction: row;
            align-items: center;
            li {
              background: rgba($color: #f2f3f4, $alpha: 1);
              border-radius: 4px;
              color: #7b858f;
              font-weight: bolder;
              padding: 4px 6px;
              font-size: 10px;
              line-height: 14px;
              margin-right: 8px;
            }
          }
        .scoreBox {
          margin-top: 16px;
          font-size: 12px;
          line-height: 17px;
          display: flex;
          align-items: center;
          .score {
            display: inline-block;
            vertical-align: middle;
            i {
              display: inline-block;
              // vertical-align: middle;
              top: 2px;
              position: relative;
              width: 16px;
              height: 16px;
            }
            i.full {
              background: url(../../../assets/img/h5/fraction_full_y.png) no-repeat;
              background-size: 16px 16px;
            }
            i.half {
              background: url(../../../assets/img/h5/fraction_half_y.png) no-repeat;
              background-size: 16px 16px;
            }
            i.none {
              background: url(../../../assets/img/h5/fraction_none_y.png) no-repeat;
              background-size: 16px 16px;
            }
            i:not(:last-child) {
              // margin-right: 4px;
            }
            span {
              font-size: 16px;
              color: #FD8850;
              line-height: 21px;
              font-weight: bolder;
              margin-left: 4px;
            }
          }
          > span {
            font-size: 12px;
            font-weight: 400;
            color: #7B858F;
            line-height: 18px;
            margin-left: 4px;
          }
        }
        .detail {
          margin-top: 17px;
          // padding: 16px 0 0;
          // border-bottom: 0.5px solid rgba(234, 234, 234, 1);
          // border-top: 0.5px solid rgba(234, 234, 234, 1);
          li {
            border-top: 0.5px solid #E8EBED;
            padding: 15px 0 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 13px;
            line-height: 20px;
            color: #333D47;
            font-weight: 400;
            a {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            .label {
              flex: 1;
              .desc {
                margin-right: 12px;
                font-weight: bolder;
                font-size: 13px;
                color: #333D47;
                line-height: 20px;
              }
              i {
                display: inline-block;
                width: 16px;
                height: 16px;
                margin-right: 12px;
                vertical-align: middle;
              }
              i.time {
                background: url(../../../assets/img/h5/time.png) no-repeat;
                background-size: 16px 16px;
              }
              i.location {
                background: url(../../../assets/img/h5/location.png) no-repeat;
                background-size: 16px 16px;
              }
              i.tel {
                background: url(../../../assets/img/h5/tel.png) no-repeat;
                background-size: 16px 16px;
              }
              span {
                vertical-align: middle;
              }
            }
            .arrow {
              margin-left: 12px;
              color: rgba(129, 129, 129, 1);
              padding-right: 20px;
              position: relative;
            }
            .arrow::before {
              content: " ";
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url(../../../assets/img/h5/arrow_r_h.png) no-repeat;
              background-size: 16px 16px;
              position: absolute;
              right: 0;
              top: 50%;
              margin-top: -8px;
            }
          }
          li:not(:last-child) {
            // margin-bottom: 12px;
          }
        }
      }
    }
    .main {
      // margin: 0 16px;
      // padding-bottom: 24px;
      .common {
        margin-top: 10px;
        background: #fff;
        padding: 24px 16px;
        .commonTop {
          margin-bottom: 15px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .topLeft {
            .title {
              font-size: 20px;
              color: #1F262E;
              line-height: 28px;
              font-weight: bolder;
              em {
                font-weight: normal;
              }
            }
          }
          .topRight {
            .more {
              font-size: 14px;
              font-weight: 400;
              color: #A1AAB3;
              line-height: 22px;
              padding-right: 20px;
              position: relative;
            }
            .more::before {
              content: " ";
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url(../../../assets/img/h5/arrow_r_g.png) no-repeat;
              background-size: 16px 16px;
              position: absolute;
              right: 0;
              top: 50%;
              margin-top: -8px;
            }
          }
        }
        .commonContent {
          margin-top: 16px;
        }
      }
      .common:not(:last-child) {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(234, 234, 234, 1);
      }
    
    }
  }
}
</style>
